import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function MenuFacturacion() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    // Función para verificar si el usuario tiene un permiso específico
    const checkPermission = (permissionSlug) => {
        if (!localStorage.getItem('userdata')) return false;
        const userData = JSON.parse(localStorage.getItem('userdata'));
        if (userData.permissions && Array.isArray(userData.permissions)) {
            return userData.permissions.some(p => p.slug === permissionSlug);
        }
        return userData.up && userData.up.includes(permissionSlug);
    };

    useEffect(()=>{

        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // Validación de permisos híbrida (nuevo + legacy)
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => 
                permission.slug === 'ver_listado_presupuestos' || 
                permission.slug === 'ver_listado_facturas' ||
                permission.slug === 'ver_listado_documentos_soporte'
            );
        } else if (userdata.up) {
            tienePermiso = userdata.up.includes('ver_listado_presupuestos') || 
                          userdata.up.includes('ver_listado_facturas') ||
                          userdata.up.includes('ver_listado_documentos_soporte');
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        axios.get('/get-client?uid='+userdata.user_id)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
                setLoggedIn(true);
            });
    },[]);

    // Protección de ruta - Patrón estándar del proyecto
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="wrapper hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="billing" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item active">Contabilidad</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Contabilidad</h1>
                                    <p className="dash-subtitle mb-0">Presupuestos, facturación y documentos electrónicos</p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="dash-card mb-4">
                            <div className="dash-card-header">
                                <h2 className="dash-card-title">
                                    <span className="title-icon" aria-hidden="true"><i className="fas fa-briefcase"></i></span>
                                    Módulos
                                </h2>
                            </div>
                            <div className="dash-card-body">
                                <div className="quick-grid">
                                    {checkPermission('ver_listado_presupuestos') && (
                                        <Link to="/listado-presupuestos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-calculator"></i></div>
                                            <p className="quick-title">Presupuesto</p>
                                            <p className="quick-sub">Cotizaciones y propuestas</p>
                                        </Link>
                                    )}

                                    {checkPermission('ver_listado_facturas') && (
                                        <Link to="/listado-facturas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-invoice"></i></div>
                                            <p className="quick-title">Facturación</p>
                                            <p className="quick-sub">Facturas y notas</p>
                                        </Link>
                                    )}

                                    {checkPermission('ver_listado_facturas') && (
                                        <Link to="/estado-cuenta-pacientes" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-wallet"></i></div>
                                            <p className="quick-title">Estado de cuenta paciente</p>
                                            <p className="quick-sub">Cartera y saldos</p>
                                        </Link>
                                    )}

                                    {checkPermission('ver_listado_documentos_soporte') && (
                                        <Link to="/listado-documentos-soporte" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                            <p className="quick-title">Documento soporte</p>
                                            <p className="quick-sub">Documentos equivalentes</p>
                                        </Link>
                                    )}

                                    {checkPermission('ver_listado_documentos_soporte') && (
                                        <Link to="/listado-egresos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-money-bill-wave"></i></div>
                                            <p className="quick-title">Egresos</p>
                                            <p className="quick-sub">Salidas y pagos</p>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}
export default MenuFacturacion;